var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "rack"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm filter_main row",
    staticStyle: {
      "margin": "1px 3px",
      "height": "40px"
    }
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "align-items": "center"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('purchaseOrder.addPurchaseOrder')))])]), _vm._v(" "), _c('div', {
    staticClass: "card-actions col-md-6 "
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Go To Purchase Order "
    },
    on: {
      "click": _vm.showList
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])]), _vm._v(" "), _c('b-card', [(_vm.showpoform) ? _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "autocomplete": "off",
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4 pofield",
    staticStyle: {
      "margin-top": "0px !important"
    }
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('purchaseOrder.name')) + ":")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "placeholder": "",
      "name": "company_name",
      "id": "company_name",
      "disabled": ""
    },
    model: {
      value: (_vm.billto.CompanyName),
      callback: function($$v) {
        _vm.billto.CompanyName = $$v
      },
      expression: "billto.CompanyName"
    }
  })], 1), _vm._v(" "), (_vm.showclientaddress) ? _c('div', {
    staticClass: "clientinfo"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('purchaseOrder.address')))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.billto.AddressLine1))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.billto.City) + ", " + _vm._s(this.billto.State))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.billto.Country) + "," + _vm._s(this.billto.PinCode))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.billto.PhoneNumber))]), _c('br')]) : _vm._e(), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "hidden",
      "placeholder": "",
      "name": "clientid",
      "id": "clientid"
    },
    model: {
      value: (_vm.poform.clientid),
      callback: function($$v) {
        _vm.poform.clientid = $$v
      },
      expression: "poform.clientid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6 pofield1 purchsOrd1"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('purchaseOrder.date')))]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "35px"
    },
    attrs: {
      "left": "<i class='\tfa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "disabled": ""
    },
    model: {
      value: (_vm.poform.podate),
      callback: function($$v) {
        _vm.poform.podate = $$v
      },
      expression: "poform.podate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 "
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('purchaseOrder.buyer')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "buyer",
      "placeholder": _vm.$t('purchaseOrder.buyerPlaceHolder')
    },
    model: {
      value: (_vm.poform.buyer),
      callback: function($$v) {
        _vm.poform.buyer = $$v
      },
      expression: "poform.buyer"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6 "
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('purchaseOrder.poDescription')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-pencil'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.poform.podescription),
      expression: "poform.podescription"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:400'),
      expression: "'max:400'"
    }],
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "name": "podescription",
      "placeholder": _vm.$t('purchaseOrder.poDescriptionPlaceHolder'),
      "maxlength": "401"
    },
    domProps: {
      "value": (_vm.poform.podescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.poform.podescription = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('podescription')),
      expression: "errors.has('podescription')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('podescription')) + "\n                        ")])], 1)], 1)])])])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('legend', [_vm._v(_vm._s(_vm.$t('purchaseOrder.terms')))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 pofield"
  }, [_c('br'), _vm._v(" "), _c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('purchaseOrder.paymentTerms')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:200'),
      expression: "'max:200'"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('purchaseOrder.paymentTermsPlaceHolder'),
      "name": "paymentterms",
      "maxlength": "201"
    },
    model: {
      value: (_vm.poform.paymentterms),
      callback: function($$v) {
        _vm.poform.paymentterms = $$v
      },
      expression: "poform.paymentterms"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('paymentterms')),
      expression: "errors.has('paymentterms')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('paymentterms')) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 pofield"
  }, [_c('br'), _vm._v(" "), _c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('purchaseOrder.Freight')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-truck'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:200'),
      expression: "'max:200'"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('purchaseOrder.FreightPlaceHolder'),
      "name": "freight",
      "maxlength": "201"
    },
    model: {
      value: (_vm.poform.freight),
      callback: function($$v) {
        _vm.poform.freight = $$v
      },
      expression: "poform.freight"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('freight')),
      expression: "errors.has('freight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('freight')) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 pofield"
  }, [_c('br'), _vm._v(" "), _c('b-form-fieldset', [_c('label', [_vm._v(" " + _vm._s(_vm.$t('purchaseOrder.FOB')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:200'),
      expression: "'max:200'"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('purchaseOrder.FOBPlaceHolder'),
      "name": "fob",
      "maxlength": "201"
    },
    model: {
      value: (_vm.poform.fob),
      callback: function($$v) {
        _vm.poform.fob = $$v
      },
      expression: "poform.fob"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fob')),
      expression: "errors.has('fob')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('fob')) + "\n                    ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4 pofield"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('purchaseOrder.carrier')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:200'),
      expression: "'max:200'"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('purchaseOrder.carrierPlaceHolder'),
      "maxlength": "201",
      "name": "carrier"
    },
    model: {
      value: (_vm.poform.carrier),
      callback: function($$v) {
        _vm.poform.carrier = $$v
      },
      expression: "poform.carrier"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('carrier')),
      expression: "errors.has('carrier')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('carrier')) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 pofield purchsOrd"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('purchaseOrder.deliveryByDate')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "35px"
    },
    attrs: {
      "left": "<i class='\tfa fa-calendar'></i>"
    }
  }, [_c('v-date-picker', {
    attrs: {
      "mode": "single",
      "events": _vm.checkdeliverydate
    },
    model: {
      value: (_vm.poform.deliverbydate),
      callback: function($$v) {
        _vm.poform.deliverbydate = $$v
      },
      expression: "poform.deliverbydate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deliveybydateerror),
      expression: "deliveybydateerror"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.deleiveryDate')) + "\n                  ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dilverydatemsg),
      expression: "dilverydatemsg"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('purchaseOrder.deliveryDateError')) + "\n                  ")])], 1)])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-headermer"
  }, [_c('a', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: "btn btn-minimize ",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }, [_c('i', {
    staticStyle: {
      "font-style": "normal"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.supplier')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: "fa fa-angle-down  ",
    staticStyle: {
      "width": "10%",
      "float": "right",
      "margin-top": "10px"
    },
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('i', {
    staticClass: "down"
  })])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1",
      "visible": ""
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.poform.suppliercompanyname),
      expression: "poform.suppliercompanyname"
    }],
    staticClass: "form-control",
    on: {
      "input": _vm.supplierChanged,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.poform.suppliercompanyname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.supplierPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.supplierlist), function(supplier_obj) {
    return _c('option', {
      attrs: {
        "label": supplier_obj.merchantname
      },
      domProps: {
        "value": supplier_obj.merchantname
      }
    })
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('supplier name')),
      expression: "errors.has('supplier name')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('supplier name')))]), _vm._v(" "), _c('datalist', {
    attrs: {
      "id": "supplier-list"
    }
  }, _vm._l((_vm.supplierlist), function(supplier_obj) {
    return _c('option', {
      attrs: {
        "label": supplier_obj.merchantname
      },
      domProps: {
        "value": supplier_obj.merchantname
      }
    })
  }))], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.supplier.suppliercompanyname) ? _c('div', [(_vm.showsupplierdata) ? _c('div', {
    staticClass: "datainfo"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('purchaseOrder.address')))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.supplier.supplieraddress))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.supplier.city) + ", " + _vm._s(_vm.supplier.state))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.supplier.country) + "," + _vm._s(_vm.supplier.pincode))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.supplier.phonenumber))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Contact Person: ")]), _c('span', [_vm._v(_vm._s(_vm.supplier.contactperson))])]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.supplierid),
      expression: "supplier.supplierid"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.supplier.supplierid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.supplier.supplierid = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.supplieraddress),
      expression: "supplier.supplieraddress"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.supplier.supplieraddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.supplier.supplieraddress = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.city),
      expression: "supplier.city"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.supplier.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.supplier.city = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.state),
      expression: "supplier.state"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.supplier.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.supplier.state = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.country),
      expression: "supplier.country"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.supplier.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.supplier.country = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.pincode),
      expression: "supplier.pincode"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.supplier.pincode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.supplier.pincode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.phonenumber),
      expression: "supplier.phonenumber"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.supplier.phonenumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.supplier.phonenumber = $event.target.value
      }
    }
  })]) : _vm._e()])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-headermer"
  }, [_c('a', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse2",
      modifiers: {
        "collapse2": true
      }
    }],
    staticClass: "btn btn-minimize ",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }, [_c('i', {
    staticStyle: {
      "font-style": "normal"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.shipTo')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse2",
      modifiers: {
        "collapse2": true
      }
    }],
    staticClass: "fa fa-angle-down  ",
    staticStyle: {
      "width": "10%",
      "float": "right",
      "margin-top": "10px"
    },
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse2",
      "visible": ""
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('b-form-fieldset', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.poform.warehousename),
      expression: "poform.warehousename"
    }],
    staticClass: "form-control",
    on: {
      "input": _vm.warehouseChanged,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.poform.warehousename = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.shipWarehouse')))]), _vm._v(" "), _vm._l((_vm.warehouselist), function(warehouse_obj) {
    return _c('option', {
      attrs: {
        "label": warehouse_obj.warehousename
      },
      domProps: {
        "value": warehouse_obj.warehousename
      }
    })
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('warehouse name')),
      expression: "errors.has('warehouse name')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('warehouse name')) + "\n                            ")]), _vm._v(" "), _c('datalist', {
    attrs: {
      "id": "warehouse-list"
    }
  }, _vm._l((_vm.warehouselist), function(warehouse_obj) {
    return _c('option', {
      attrs: {
        "label": warehouse_obj.warehousename
      },
      domProps: {
        "value": warehouse_obj.warehousename
      }
    })
  }))], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.poform.warehouseid) ? _c('div', [(_vm.showwarehousedata) ? _c('div', {
    staticClass: "datainfo"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('purchaseOrder.address')))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.warehouse.warehouseaddress) + " ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.warehouse.warehousecity) + ", " + _vm._s(_vm.warehouse.warehousestate))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.warehouse.warehousecountry) + "," + _vm._s(_vm.warehouse.warehousepincode))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.warehouse.contactno))]), _c('br')]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.poform.warehouseid),
      expression: "poform.warehouseid"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.poform.warehouseid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.poform.warehouseid = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.warehouse.warehouseaddress),
      expression: "warehouse.warehouseaddress"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.warehouse.warehouseaddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.warehouse.warehouseaddress = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.warehouse.warehousecity),
      expression: "warehouse.warehousecity"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.warehouse.warehousecity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.warehouse.warehousecity = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.warehouse.warehousestate),
      expression: "warehouse.warehousestate"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.warehouse.warehousestate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.warehouse.warehousestate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.warehouse.warehousecountry),
      expression: "warehouse.warehousecountry"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.warehouse.warehousecountry)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.warehouse.warehousecountry = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.warehouse.warehousepincode),
      expression: "warehouse.warehousepincode"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.warehouse.warehousepincode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.warehouse.warehousepincode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.warehouse.contactno),
      expression: "warehouse.contactno"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.warehouse.contactno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.warehouse.contactno = $event.target.value
      }
    }
  })]) : _vm._e()])], 1)])], 1)], 1)])]), _vm._v(" "), _c('fieldset', [(_vm.checkgsterror) ? _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.SupplierShipPlaceholder'))), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.selecteditemerror) ? _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v(_vm._s(_vm.selcteditemerrormsg)), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table-bordered additems_table"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "height": "50px !important"
    }
  }, [_c('th', {
    staticClass: "tableheader",
    attrs: {
      "width": "3%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.sr')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    attrs: {
      "width": "18%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.ProductName')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.hsnCode')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    attrs: {
      "width": "7%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.qty')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.Uom')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    attrs: {
      "width": "7%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.mrp')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    attrs: {
      "width": "7%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.ptr')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.discount')) + " (%)")]), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    attrs: {
      "width": "8%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.total')))]), _vm._v(" "), (_vm.checkcgst) ? _c('th', {
    staticClass: "tableheader",
    attrs: {
      "width": "7%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.gst')))]) : _vm._e(), _vm._v(" "), (_vm.checkcgst) ? _c('th', {
    staticClass: "tableheader",
    attrs: {
      "width": "7%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.cgst')) + " %")]) : _vm._e(), _vm._v(" "), (_vm.checkcgst) ? _c('th', {
    staticClass: "tableheader",
    attrs: {
      "width": "7%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.cgstRate')))]) : _vm._e(), _vm._v(" "), (_vm.checkcgst) ? _c('th', {
    staticClass: "tableheader",
    attrs: {
      "width": "7%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.sgst')) + " %")]) : _vm._e(), _vm._v(" "), (_vm.checkcgst) ? _c('th', {
    staticClass: "tableheader",
    attrs: {
      "width": "7%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.sgstRate')))]) : _vm._e(), _vm._v(" "), (_vm.checkigst) ? _c('th', {
    staticClass: "tableheader",
    attrs: {
      "width": "7%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.igst')) + " %")]) : _vm._e(), _vm._v(" "), (_vm.checkigst) ? _c('th', {
    staticClass: "tableheader",
    attrs: {
      "width": "7%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.igstRate')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    attrs: {
      "width": "8%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.totalIncludingTaxes')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('warehouseClientList.action')))])])]), _vm._v(" "), _vm._l((_vm.itemsWithSubTotal), function(invoice_item, index) {
    return _c('tbody', [_c('tr', [_c('td', {
      attrs: {
        "width": "3%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "18%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (invoice_item.item.productname),
        expression: "invoice_item.item.productname"
      }],
      staticClass: "productname",
      staticStyle: {
        "height": "30px"
      },
      attrs: {
        "list": "newssources-list",
        "name": "source-selection",
        "id": "source-selection",
        "placeholder": _vm.$t('purchaseOrder.SelectProduct'),
        "ind": index,
        "autocomplete": "off"
      },
      domProps: {
        "value": (invoice_item.item.productname)
      },
      on: {
        "change": _vm.sourceChanged,
        "keyup": _vm.getProducts,
        "input": function($event) {
          if ($event.target.composing) { return; }
          invoice_item.item.productname = $event.target.value
        }
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.searchproducts(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.searchProduct')))])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(invoice_item.item.hsncode))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "7%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (invoice_item.item.quantity),
        expression: "invoice_item.item.quantity",
        modifiers: {
          "number": true
        }
      }],
      class: (_vm.qtyshowerror == true && invoice_item.item.clientproductid != '' && invoice_item.item.quantity == '') ? 'input-invalid' : '',
      staticStyle: {
        "height": "30px"
      },
      attrs: {
        "type": "number",
        "id": index,
        "state": false,
        "min": "0"
      },
      domProps: {
        "value": (invoice_item.item.quantity)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          invoice_item.item.quantity = _vm._n($event.target.value)
        }, function($event) {
          _vm.checkqty(invoice_item.item.quantity)
        }],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(invoice_item.item.uom))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "7%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (invoice_item.item.mrp),
        expression: "invoice_item.item.mrp",
        modifiers: {
          "number": true
        }
      }],
      class: (invoice_item.item.mrpshowerror == true) ? 'input-invalid' : '',
      attrs: {
        "type": "number",
        "step": "any"
      },
      domProps: {
        "value": (invoice_item.item.mrp)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          invoice_item.item.mrp = _vm._n($event.target.value)
        }, function($event) {
          _vm.checkproductalreadyadded(index)
        }],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "7%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (invoice_item.item.unitprice),
        expression: "invoice_item.item.unitprice",
        modifiers: {
          "number": true
        }
      }],
      class: (_vm.unitprshowerror == true && invoice_item.item.clientproductid != '' && invoice_item.item.unitprice == '') ? 'input-invalid' : '',
      staticStyle: {
        "height": "30px"
      },
      attrs: {
        "type": "number",
        "min": "0",
        "ind1": index,
        "step": "any"
      },
      domProps: {
        "value": (invoice_item.item.unitprice)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          invoice_item.item.unitprice = _vm._n($event.target.value)
        }, _vm.checkproductadded],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "5%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (invoice_item.item.discount),
        expression: "invoice_item.item.discount",
        modifiers: {
          "number": true
        }
      }],
      staticStyle: {
        "height": "30px"
      },
      attrs: {
        "type": "number",
        "min": "0"
      },
      domProps: {
        "value": (invoice_item.item.discount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          invoice_item.item.discount = _vm._n($event.target.value)
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "subtotal",
      attrs: {
        "width": "8%",
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm.getScore(invoice_item.subtotal)))]), _vm._v(" "), (_vm.checkcgst) ? _c('td', {
      attrs: {
        "width": "7%"
      }
    }, [_c('b-form-select', {
      attrs: {
        "options": _vm.gstoptions
      },
      on: {
        "input": function($event) {
          _vm.setgstrates(index)
        }
      },
      model: {
        value: (invoice_item.item.gst),
        callback: function($$v) {
          invoice_item.item.gst = $$v
        },
        expression: "invoice_item.item.gst"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.checkcgst) ? _c('td', {
      attrs: {
        "width": "7%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (invoice_item.item.cgst),
        expression: "invoice_item.item.cgst"
      }],
      attrs: {
        "disabled": ""
      },
      domProps: {
        "value": (invoice_item.item.cgst)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          invoice_item.item.cgst = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.checkcgst) ? _c('td', {
      attrs: {
        "width": "7%",
        "align": "right"
      }
    }, [_vm._v(_vm._s(invoice_item.cgstrate))]) : _vm._e(), _vm._v(" "), (_vm.checkcgst) ? _c('td', {
      attrs: {
        "width": "7%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (invoice_item.item.sgst),
        expression: "invoice_item.item.sgst"
      }],
      attrs: {
        "disabled": ""
      },
      domProps: {
        "value": (invoice_item.item.sgst)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          invoice_item.item.sgst = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.checkcgst) ? _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(invoice_item.sgstrate))]) : _vm._e(), _vm._v(" "), (_vm.checkigst) ? _c('td', {
      attrs: {
        "width": "7%"
      }
    }, [_c('b-form-select', {
      attrs: {
        "options": _vm.igstoptions
      },
      model: {
        value: (invoice_item.item.igst),
        callback: function($$v) {
          invoice_item.item.igst = $$v
        },
        expression: "invoice_item.item.igst"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.checkigst) ? _c('td', {
      attrs: {
        "width": "7%",
        "align": "right"
      }
    }, [_vm._v(_vm._s(invoice_item.igstrate))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "subtotal",
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm.getScore(invoice_item.totalincludetaxes)))]), _vm._v(" "), _c('td', {
      staticClass: "subtotal",
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "width": "5%"
      }
    }, [_c('a', {
      staticClass: "submitbutton",
      attrs: {
        "size": "sm",
        "variant": "success"
      },
      on: {
        "click": function($event) {
          _vm.deleterow(invoice_item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      staticStyle: {
        "color": "#ff0000",
        "font-size": "15px"
      }
    })])])])])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "glassbox",
    staticStyle: {
      "color": "white",
      "height": "30px",
      "text-align": "center",
      "width": "80px",
      "padding-top": "5px"
    },
    on: {
      "click": _vm.addRow
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.$t('purchaseOrder.addItem')))]), _vm._v(" "), _c('datalist', {
    attrs: {
      "id": "newssources-list"
    }
  }, _vm._l((_vm.products), function(source) {
    return _c('option', {
      attrs: {
        "label": source.productname
      },
      domProps: {
        "value": source.productname
      }
    })
  }))])])])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('legend', {
    staticStyle: {
      "margin-bottom": "0px !important"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.comments')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.poform.comments),
      expression: "poform.comments"
    }],
    staticStyle: {
      "width": "100%",
      "height": "60%"
    },
    attrs: {
      "placeholder": _vm.$t('purchaseOrder.commentsPlaceHolder')
    },
    domProps: {
      "value": (_vm.poform.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.poform.comments = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "subtotal_div",
    staticStyle: {
      "text-align": "right",
      "margin-right": "20px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered",
    staticStyle: {
      "width": "70%",
      "float": "right"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.subTotal')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getScore(_vm.total)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.shipping')))]), _vm._v(" "), _c('td', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-truck'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "placeholder": "",
      "name": "shipping",
      "id": "shipping"
    },
    model: {
      value: (_vm.poform.shippingcharges),
      callback: function($$v) {
        _vm.poform.shippingcharges = _vm._n($$v)
      },
      expression: "poform.shippingcharges"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.total')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getScore(_vm.finaltotal)))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pofooter form-actions"
  }, [_c('b-button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitinvoice
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.reset')))]), _vm._v(" "), _c('br'), (_vm.iserror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.requiredFields')) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.itemlinerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.fillfields')) + "\n              ")]) : _vm._e()], 1)])]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Alert Message"
    },
    model: {
      value: (_vm.modalMessageShowpo),
      callback: function($$v) {
        _vm.modalMessageShowpo = $$v
      },
      expression: "modalMessageShowpo"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.modalMessageShowpo = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.successemsg))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.modalMessageShowpo = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.createNewPo')))]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-setting d-sm-down-none",
    attrs: {
      "to": 'purchaseOrder'
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.gotolisting
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.goToListing')))])])], 1)])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.searchmodalShow),
      callback: function($$v) {
        _vm.searchmodalShow = $$v
      },
      expression: "searchmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.searchProduct')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.searchmodalShow = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), (_vm.showserchproductform) ? _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off",
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4 "
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.clientProductId')))]), _vm._v(" "), _c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:200'),
      expression: "'max:200'"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('productPlaceHolder.clientProductIdPlaceHolder'),
      "name": "Clientproductid",
      "maxlength": "201"
    },
    model: {
      value: (_vm.searchproduct.clientproductid),
      callback: function($$v) {
        _vm.searchproduct.clientproductid = $$v
      },
      expression: "searchproduct.clientproductid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 "
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('product.productName')))]), _vm._v(" "), _c('b-input-group', [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:200'),
      expression: "'max:200'"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.productNamePlaceHolder'),
      "name": "Productname",
      "maxlength": "201"
    },
    model: {
      value: (_vm.searchproduct.productname),
      callback: function($$v) {
        _vm.searchproduct.productname = $$v
      },
      expression: "searchproduct.productname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 "
  }, [_c('b-button', {
    staticClass: "glass",
    staticStyle: {
      "margin-top": "40px !important"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.searchproductsdata(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.search')))])], 1)]), _vm._v(" "), _c('div', [_c('loader', {
    attrs: {
      "isLoading": _vm.isproductloading,
      "is-full-screen": false
    }
  }), _vm._v(" "), (_vm.searchproductloopdata.length == 0 && _vm.shownoproductfound) ? _c('div', {
    staticClass: "alert-info"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('purchaseOrder.productNotFound')))])]) : _vm._e(), _vm._v(" "), (_vm.searchproductloopdata.length > 0) ? _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "overflow-x": "auto",
      "margin-left": "30px"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('div', {
    staticClass: "alert-info"
  }, [_c('p', [_c('strong', [_vm._v(" " + _vm._s(_vm.$t('purchaseOrder.clickChooseProduct')) + " ")])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered",
    staticStyle: {
      "min-width": "50%"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('product.clientProductId')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center !important"
    }
  }, [_vm._v(_vm._s(_vm.$t('product.productName')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center !important"
    }
  }, [_vm._v(_vm._s(_vm.$t('warehouseClientList.action')))])])]), _vm._v(" "), _vm._l((_vm.searchproductloopdata), function(product) {
    return _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(product.clientproductid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(product.productname))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "glassbox",
      staticStyle: {
        "color": "white",
        "height": "30px",
        "text-align": "center",
        "width": "80px",
        "padding-top": "5px"
      },
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.setproductline(product.productid)
        }
      }
    }, [_vm._v("Select")])])])])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.pagecount) ? _c('b-pagination', {
    staticClass: "mt-4",
    attrs: {
      "total-rows": _vm.pagecount * 10,
      "per-page": 10,
      "aria-controls": "my-table",
      "first-text": "⏮",
      "prev-text": "⏪",
      "next-text": "⏩",
      "last-text": "⏭"
    },
    on: {
      "input": function($event) {
        _vm.getPaginationData(_vm.currentPage)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }) : _vm._e()], 1)]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  })])])])], 1)])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2cf7048a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cf7048a","hasScoped":true}!./src/views/components/purchaseOrder/po.component.html
// module id = 1248
// module chunks = 0